/**
 * Plug and Play Mode Configuration
 * Separates system from ISO mode for faster development
 */

interface MenuItem {
  to: string;
  [key: string]: any;
}

const PLUG_AND_PLAY_MENU_PATHS = [
  '/my-tasks',
  '/projects',
  '/document-master-list'
] as const;

const PLUG_AND_PLAY_ONLY_PATHS = ['/document-master-list'] as const;

const isPlugAndPlayEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_PLUG_AND_PLAY === 'true';
};

const isMenuAllowed = (
  menuPath: string,
  allowedPaths: readonly string[]
): boolean => {
  return allowedPaths.includes(menuPath);
};

const isEnabled = isPlugAndPlayEnabled();

export const plugAndPlayConfig = {
  isEnabled,
  allowedMenuPaths: PLUG_AND_PLAY_MENU_PATHS,

  filterMenuItems: <T extends MenuItem>(menuItems: T[]): T[] => {
    if (isEnabled) {
      // Plug and Play mode: show only allowed menus
      return menuItems.filter((item) =>
        isMenuAllowed(item.to, PLUG_AND_PLAY_MENU_PATHS)
      );
    } else {
      // Normal ISO mode: hide Plug and Play only menus
      return menuItems.filter(
        (item) => !isMenuAllowed(item.to, PLUG_AND_PLAY_ONLY_PATHS)
      );
    }
  }
};

export default plugAndPlayConfig;
